var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"transfer-icon-wrapper",on:{"mousedown":_vm.iconPress}},[_c('Icon',{staticClass:"transfer-icon",attrs:{"width":18,"height":13}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }